/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { useFormContext } from "react-hook-form";

// CSS読み込み
import {
  checkInput,
  inputArea_subCheck,
} from "assets/css/stylesCss";

/**
 * アコーディオン内のチェックボックス
 * @param {String} id for属性用ID
 * @param {String} name react-hook-form管理用フォーム特定文字列
 * @param {String} value value属性用初期値
 * @param {String} children 子要素
 * @param {Object} rules バリデーション設定オブジェクト
 */
const AccordionCheckBox = memo(({ id, name, value, children, rules }) => {
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
  } = useFormContext();

  return (
    <>
      <label
        css={inputArea_subCheck}
        htmlFor={id}
      >
        <input
          css={checkInput}
          {...register(name, {
            ...rules,
            validate: {
              // チェックボックスがチェックされているかの判定
              isChecked: () => {
                if(isChecked(name) === true) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            onChange: () =>
              // mode設定(onBlur)によりタップ後フォーカスを外すまで反応しないため、例外的にリアルタイムでバリデーションを実行
              setValue(name, getValues(name), {
                shouldValidate: true,
              }),
          })}
          type="checkbox"
          id={id}
          name={name}
          value={value}
        />
        {children}
      </label>
    </>
  );
});

/**
 * チェックボックスがチェックされているか判定
 * @returns true:引数で渡されたname属性にチェックあり
 *          false:引数で渡されたname属性にチェックなし
 */
const isChecked = (name) => {

  const checkArr = document.getElementsByName(name);

  var result = false;

  checkArr.forEach(element => {
    if(element.checked === true) {
      result = true;
    }
  });

  return result;
}

export default AccordionCheckBox;
